var _defs, _path, _path2, _path3, _path4, _path5, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 342 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_84a848015ca85d19b5c3b12a8c03b9c2a3d75626bb03c2d4ff796558a2c43d09",
    x1: -2.721,
    y1: 41.741,
    x2: 94.115,
    y2: 41.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#612d87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#a21a71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_84a848015ca85d19b5c3b12a8c03b9c2a3d75626bb03c2d4ff796558a2c43d09",
    x1: -2.975,
    y1: 31.853,
    x2: 94.061,
    y2: 31.853,
    xlinkHref: "#SVGID_0_84a848015ca85d19b5c3b12a8c03b9c2a3d75626bb03c2d4ff796558a2c43d09"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_84a848015ca85d19b5c3b12a8c03b9c2a3d75626bb03c2d4ff796558a2c43d09",
    x1: 344.072,
    y1: 39.679,
    x2: 246.257,
    y2: 39.679,
    xlinkHref: "#SVGID_0_84a848015ca85d19b5c3b12a8c03b9c2a3d75626bb03c2d4ff796558a2c43d09"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_84a848015ca85d19b5c3b12a8c03b9c2a3d75626bb03c2d4ff796558a2c43d09",
    x1: 344.491,
    y1: 33.248,
    x2: 245.857,
    y2: 33.248,
    xlinkHref: "#SVGID_0_84a848015ca85d19b5c3b12a8c03b9c2a3d75626bb03c2d4ff796558a2c43d09"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_84a848015ca85d19b5c3b12a8c03b9c2a3d75626bb03c2d4ff796558a2c43d09",
    x1: 201.546,
    y1: 30.387,
    x2: 212.53,
    y2: 30.387,
    gradientTransform: "rotate(-180 207.038 30.387)",
    xlinkHref: "#SVGID_0_84a848015ca85d19b5c3b12a8c03b9c2a3d75626bb03c2d4ff796558a2c43d09"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_84a848015ca85d19b5c3b12a8c03b9c2a3d75626bb03c2d4ff796558a2c43d09",
    x1: 138.526,
    y1: 30.387,
    x2: 127.542,
    y2: 30.387,
    xlinkHref: "#SVGID_0_84a848015ca85d19b5c3b12a8c03b9c2a3d75626bb03c2d4ff796558a2c43d09"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M92.865 33.409c-4.067.071-19.268-.129-36.595-6.226-2.439-.858-4.974-1.897-7.426-2.901-14.879-6.096-27.73-11.359-37.246 9.098-2.735 5.879-4.819 11.38-6.658 16.232C2.857 55.11.954 60.134-1.471 64.662",
    stroke: "url(#SVGID_0_84a848015ca85d19b5c3b12a8c03b9c2a3d75626bb03c2d4ff796558a2c43d09)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M-1.725 50.561c.346-.905.697-1.83 1.055-2.775 1.875-4.949 4-10.559 6.828-16.638C18.091 5.5 36.404 13.001 51.119 19.029c2.493 1.021 4.847 1.985 7.144 2.794 16.353 5.755 31.025 5.934 34.548 5.883",
    stroke: "url(#SVGID_1_84a848015ca85d19b5c3b12a8c03b9c2a3d75626bb03c2d4ff796558a2c43d09)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M342.822 30.833c-.265.329-.532.662-.8 1-10.096 12.734-21.385 16.692-31.938 16.692-11.332 0-21.814-4.562-29.065-7.718l-1.801-.781c-18.093-7.783-31.576-6.987-31.712-6.979",
    stroke: "url(#SVGID_2_84a848015ca85d19b5c3b12a8c03b9c2a3d75626bb03c2d4ff796558a2c43d09)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M247.107 28.462c.606-.042 15.074-.896 34.482 7.453l1.824.791c14.271 6.21 35.835 15.595 53.907-7.201a140.317 140.317 0 015.921-7.008",
    stroke: "url(#SVGID_3_84a848015ca85d19b5c3b12a8c03b9c2a3d75626bb03c2d4ff796558a2c43d09)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M221.584 50.431H211.28V10.343h10.304c11.063 0 20.044 8.981 20.044 20.044s-8.981 20.044-20.044 20.044zM244.199 35.476h-2.571V25.299h2.571a3.01 3.01 0 013.008 3.008v4.162a3.01 3.01 0 01-3.008 3.008zM184.427 16.785h18.369v5.917h-18.369a2.96 2.96 0 01-2.959-2.959 2.96 2.96 0 012.959-2.959zM184.427 38.072h18.369v5.917h-18.369a2.96 2.96 0 01-2.959-2.959 2.96 2.96 0 012.959-2.959zM118.488 10.343h10.304v40.088h-10.304c-11.063 0-20.044-8.981-20.044-20.044s8.981-20.044 20.044-20.044zM95.873 25.298h2.571v10.177h-2.571a3.01 3.01 0 01-3.008-3.008v-4.162a3.01 3.01 0 013.008-3.008z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "MI_4L_gradient",
    x: 202.796,
    y: 6.332,
    width: 8.484,
    height: 48.11,
    rx: 4.219,
    ry: 4.219,
    transform: "rotate(180 207.038 30.387)",
    stroke: "url(#SVGID_4_84a848015ca85d19b5c3b12a8c03b9c2a3d75626bb03c2d4ff796558a2c43d09)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "MI_4L_gradient",
    x: 128.792,
    y: 6.332,
    width: 8.484,
    height: 48.11,
    rx: 4.219,
    ry: 4.219,
    stroke: "url(#SVGID_5_84a848015ca85d19b5c3b12a8c03b9c2a3d75626bb03c2d4ff796558a2c43d09)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnected);
export default __webpack_public_path__ + "static/media/disconnected.9bffd73bef0f0480d2b2629158ee0275.svg";
export { ForwardRef as ReactComponent };